import {Toast as BootstrapToast} from 'react-bootstrap';
import {ToastProps, useToasts} from 'react-toast-notifications';
import React, {useCallback} from 'react';

const appearanceMapper = {
  success: 'success',
  error: 'danger',
  info: 'info',
  warning: 'warning',
};
const textColorMapper = {
  success: 'text-bg-dark',
  error: 'text-bg-dark',
  info: 'text-bg-light',
  warning: 'text-bg-dark',
};
export const Toast = ({
  appearance,
  children,
  onDismiss,
  autoDismissTimeout,
  autoDismiss,
}: ToastProps): React.ReactElement => (
  <BootstrapToast
    animation
    bg={appearanceMapper[appearance]}
    className={textColorMapper[appearance]}
    onClose={() => onDismiss()}
    autohide={!!autoDismiss}
    delay={autoDismissTimeout}>
    <BootstrapToast.Header>
      <strong className="me-auto">PathX</strong>
      <small />
    </BootstrapToast.Header>
    <BootstrapToast.Body>{children}</BootstrapToast.Body>
  </BootstrapToast>
);

export const useToast = (): {
  readonly errorMessage: (message: any) => void;
  readonly successMessage: (message: any) => void;
  readonly warnMessage: (message: any) => void;
} => {
  const {addToast} = useToasts();
  const successMessage = useCallback(
    message => {
      addToast(message, {appearance: 'success'});
    },
    [addToast],
  );
  const errorMessage = useCallback(
    message => {
      addToast(message, {appearance: 'error'});
    },
    [addToast],
  );
  const warnMessage = useCallback(
    message => {
      addToast(message, {appearance: 'warning'});
    },
    [addToast],
  );
  return {
    successMessage,
    errorMessage,
    warnMessage,
  };
};
